import React from 'react';
import { NavLink } from 'react-router-dom';

import Icon from 'components/generic/Icon.component';
import LINK from 'constants/link.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import linkTo from 'utils/links/linkTo.util';

import CN from './CogButton.module.scss';

const CogButton = ({ tag }) => {
  const salonId = useCurrentSalonId();

  const params = Object.freeze({ salonId, id: salonId });
  const settingsCalendar = linkTo({ pattern: LINK.settingsCalendar, params });

  return (
    <div className={CN.component} data-bem="CogButton" data-tag={fromAnyToTrimmed(tag)}>
      <NavLink to={settingsCalendar} className={CN.button}>
        <Icon variant="cog" selected width="xl" />
      </NavLink>
    </div>
  );
};

export default CogButton;
